import createAxios from './api'

const PATH = 'users/self/credentials'

export default {
  async listMyActivatedCredentials() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/activated`)
    return resp.data
  }
}
